/**
 * @copyright © Paramount Streaming
 * @author  Stan Gletski
 * @description Player adapter events
 */
export enum PlayerAdapterEvent {
	ACTION_KEY = 'actionkey',
	ACTION_KEY_METADATA = 'actionkeymetadata',
	ACTIVE_STATE_CHANGE = 'activestatechange',
	AD_BREAK_COMPLETE = 'adbreakcomplete',
	AD_BREAK_DISCARDED = 'adbreakdiscarded',
	AD_BREAK_METADATA = 'adbreakmetadata',
	AD_BREAK_START = 'adbreakstart',
	AD_CLICK = 'adclick',
	AD_COMPLETE = 'adcomplete',
	AD_CUEPOINTS_AVAILABLE = 'adcuepointsavailable',
	AD_FIRST_QUARTILE = 'adfirstquartile',
	AD_MIDPOINT = 'admidpoint',
	AD_PAUSED = 'adpaused',
	AD_PLAYING = 'adplaying',
	AD_PROGRESS = 'adprogress',
	AD_SEGMENT_END = 'adsegmentend',
	AD_SEGMENT_REENTERED = 'adsegmentreentered',
	AD_SEGMENT_START = 'adsegmentstart',
	AD_SKIPPABLE_STATE_CHANGE = 'adskippablestatechange',
	AD_SKIPPED = 'adskipped',
	AD_STALLED = 'adstalled',
	AD_START = 'adstart',
	AD_THIRD_QUARTILE = 'adthirdquartile',
	AUDIO_TRACK_CHANGE = 'audiotrackchange',
	AUDIO_TRACKS_CHANGE = 'audiotrackschange',
	AUTOPLAY_BLOCKED = 'autoplayblocked',
	CDN_CHANGE = 'cdnchange',
	CLOCK = 'aviaclock',
	CONTENT_COMPLETE = 'contentcomplete',
	CONTENT_DURATION_AVAILABLE = 'contentdurationavailable',
	CONTENT_IS_PLAYING_LIVE = 'contentisplayinglive',
	CONTENT_PAUSED = 'contentpaused',
	CONTENT_PLAYING = 'contentplaying',
	CONTENT_PROGRESS = 'contentprogress',
	CONTENT_SEGMENT_END = 'contentsegmentend',
	CONTENT_SEGMENT_START = 'contentsegmentstart',
	CONTENT_START = 'contentstart',
	DRM_KEY_SYSTEM_CREATED = 'drmkeysystemcreated',
	ERROR = 'error',
	FULLSCREEN_CHANGE = 'fullscreenchange',
	HIDE_AD_UI = 'hideadui',
	LANGUAGE_CHANGE = 'languagechange',
	LIVE_PRESENTATION_STOPPED = 'livepresentationstopped',
	LOG_EVENT = 'logevent',
	METADATA_CUEPOINT = 'metadatacuepoint',
	METRIC = 'metric',
	MUTE_CHANGE = 'mutechange',
	PLAYBACK_RESUMED = 'playbackresumed',
	PLAYBACK_STARTED = 'playbackstarted',
	PLAYBACK_STATE_CHANGE = 'playbackstatechange',
	PLAYBACK_SUSPENDED = 'playbacksuspended',
	PLUGIN_EVENT = 'pluginevent',
	PRESENTATION_SIZE_CHANGE = 'presentationsizechange',
	QUALITIES_CHANGE = 'qualitieschange',
	QUALITY_CHANGE = 'qualitychange',
	READY = 'ready',
	RESOURCE_BUFFERING = 'resourcebuffering',
	RESOURCE_END = 'resourceend',
	RESOURCE_START = 'resourcestart',
	SEEK_COMPLETE = 'seekcomplete',
	SEEK_REDIRECT_COMPLETE = 'seekredirectcomplete',
	SEEK_REDIRECT_START = 'seekredirectstart',
	SEEK_START = 'seekstart',
	SHOW_AD_UI = 'showadui',
	SQUEEZEBACK_END = 'squeezebackend',
	SQUEEZEBACK_START = 'squeezebackstart',
	STREAM_ID_AVAILABLE = 'streamidavailable',
	STREAM_METADATA = 'streammetadata',
	STREAM_TYPE_CHANGE = 'streamtypechange',
	TEXT_CUEPOINT = 'textcuepoint',
	TEXT_TRACK_AVAILABLE = 'texttrackavailable',
	TEXT_TRACK_CHANGE = 'texttrackchange',
	TEXT_TRACK_ENABLED_CHANGE = 'texttrackenabledchange',
	TEXT_TRACKS_CHANGE = 'texttrackschange',
	THUMBNAIL_TRACK_AVAILABLE = 'thumbnailtrackavailable',
	VIDEO_ELEMENT_ADDED = 'videoelementadded',
	VIDEO_ELEMENT_REMOVED = 'videoelementremoved',
	VOLUME_CHANGE = 'volumechange',
	WAITING_CHANGE = 'waitingchange'
}